import { render, staticRenderFns } from "./EsperienzeBigSlider.vue?vue&type=template&id=574220d2&"
import script from "./EsperienzeBigSlider.vue?vue&type=script&lang=js&"
export * from "./EsperienzeBigSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports